import React from "react";
import { ArrowDown, ArrowUpRight, MapPin, MessageSquare } from "lucide-react";
import { motion } from "framer-motion";
import bannerImg from "../assets/banner.webp";
import logoImg from "../assets/jalsa-logo.jpeg";

function HeroSection({ heroY, heroScale, setReserveOpen, scrollTo }) {
  return (
    <section id="home" className="hero">
      <motion.div className="hero-bg" style={{ y: heroY, scale: heroScale }}>
        <div
          className="hero-image"
          style={{ backgroundImage: `url(${bannerImg})` }}
        />
      </motion.div>
      <div className="hero-vignette" />
      <div className="hero-noise" />

      <div className="hero-center-wrapper">
        <motion.div
          className="hero-card"
          initial={{ opacity: 0, scale: 0.95, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero-card-inner">
            <div className="card-est">E S T . &nbsp;|&nbsp; 2 0 1 7</div>

            <div className="card-brand">
              <img src={logoImg} alt="Jalsa logo" className="card-logo" />
              <div className="card-title">
                <h1>THE JALSA</h1>
                <p className="card-subtitle">RESTOBAR & KITCHEN</p>
              </div>
            </div>

            <p className="card-location">
              Whitefield &nbsp;|&nbsp; Bengaluru, India
            </p>

            <button
              className="card-reserve-btn"
              onClick={() => setReserveOpen(true)}
            >
              Reserve a table <ArrowUpRight size={16} />
            </button>
          </div>
        </motion.div>
      </div>

      <div className="hero-bottom-bar">
        <button
          className="chat-pill-btn"
          onClick={() => setReserveOpen(true)}
        >
          <MessageSquare size={16} fill="currentColor" /> Let's Chat!
        </button>

        <span className="hero-location-tag">
          <MapPin size={14} /> Whitefield, Bengaluru
        </span>
      </div>
    </section>
  );
}

export default HeroSection;
